module.exports = __webpack_public_path__ + "static/media/Arrow-up-white.41f2ac0d.svg";